import Step2New from "./Step2New";

export default Step2New;